"use client";

import {JSX, MouseEvent} from "react";

import {useTranslation} from "@/shared/i18n";

import "./styles/select-option.scss";

interface SelectOptionProps<T = unknown> {
    option: T & {label: string; labelKey?: string; labelParams?: Record<string, string | number>; disabled?: boolean};
    isSelected: boolean;
    isMultiple: boolean;
    onClick: (option: T & {label: string; disabled?: boolean}, e: MouseEvent) => void;
}

export function SelectOption<T = unknown>({option, isSelected, isMultiple, onClick}: SelectOptionProps<T>): JSX.Element {
    const {t} = useTranslation();

    // Use translated label if labelKey is provided, otherwise use label
    const displayLabel = option.labelKey ? t(option.labelKey as Parameters<typeof t>[0], option.labelParams) : option.label;

    return (
        <li
            onMouseDown={(e) => onClick(option, e)}
            className={`select-field__option ${isSelected ? "is-selected" : ""} ${option.disabled ? "is-disabled" : ""}`}
        >
            {isMultiple && <input type="checkbox" checked={isSelected} disabled={option.disabled} readOnly className="select-field__checkbox" />}
            <span className="select-field__option-label">{displayLabel}</span>
        </li>
    );
}
